import React from 'react';
import ModalWrapper from '../shared/ModalWrapper';
function SimpleShareContentModal(_ref) {
  var data = _ref.data,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    data: data,
    onClose: onClose
  });
}
export default SimpleShareContentModal;